"use strict";

var cov_1ipqa8cc5w = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\chapters\\index.js";
  var hash = "0e4922258c8ca62ba0809ed252ef1113b5ac0ffb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\chapters\\index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "0e4922258c8ca62ba0809ed252ef1113b5ac0ffb"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Chapter", {
  enumerable: true,
  get: function get() {
    return _Chapter.default;
  }
});
Object.defineProperty(exports, "Chapters", {
  enumerable: true,
  get: function get() {
    return _Chapters.default;
  }
});

var _Chapter = _interopRequireDefault(require("./Chapter"));

var _Chapters = _interopRequireDefault(require("./Chapters"));